import { Layout } from '@/components/Layout';
import { ExternalLink } from 'lucide-react';

export default function Sportsbooks() {
  const sportsbooks = [
    {
      name: 'PrizePicks',
      description: 'Daily fantasy sports platform with player prop contests',
      url: 'https://prizepicks.onelink.me/FjtC/d9ee5h8t',
      color: 'border-primary',
      highlight: 'Most Popular'
    },
    {
      name: 'Betr',
      description: 'Micro-betting platform with instant prop bets',
      url: 'https://engagebetr.onelink.me/auSX/STATLAB',
      color: 'border-accent',
      highlight: 'STATLAB Exclusive'
    },
    {
      name: 'Novig',
      description: 'Peer-to-peer sports betting marketplace',
      url: 'https://novig.onelink.me/JHQQ/5wk3auau',
      color: 'border-secondary',
      highlight: 'New Platform'
    },
    {
      name: 'Pickit',
      description: 'Track your bets and analyze performance',
      url: 'https://links.pikkit.com/invite/spike57911',
      color: 'border-push',
      highlight: 'Bet Tracking'
    }
  ];

  return (
    <Layout>
      <div className="container mx-auto px-6 md:px-12 py-12" data-testid="sportsbooks-page">
        <div className="mb-12">
          <h1 className="text-5xl md:text-6xl font-heading font-bold mb-4">RECOMMENDED SPORTSBOOKS</h1>
          <p className="text-lg text-muted-foreground max-w-3xl">
            Sign up with our trusted partners to place your bets. Each platform offers unique features and competitive lines.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {sportsbooks.map((book, index) => (
            <a
              key={index}
              href={book.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`bg-card border-2 ${book.color} p-8 hover:bg-surface-highlight transition-all duration-300 group`}
              data-testid={`sportsbook-${book.name.toLowerCase()}`}
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h2 className="text-3xl font-heading font-bold mb-2 group-hover:text-primary transition-colors">
                    {book.name}
                  </h2>
                  {book.highlight && (
                    <span className="inline-block px-3 py-1 bg-primary/20 text-primary text-xs font-mono uppercase tracking-widest mb-3">
                      {book.highlight}
                    </span>
                  )}
                </div>
                <ExternalLink className="text-muted-foreground group-hover:text-primary transition-colors" size={24} />
              </div>
              <p className="text-muted-foreground leading-relaxed mb-6">
                {book.description}
              </p>
              <div className="font-mono text-sm uppercase tracking-widest text-primary group-hover:underline">
                Sign Up Now →
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 p-8 bg-surface-highlight border border-border">
          <h3 className="font-heading text-xl font-bold mb-4">WHY USE THESE PLATFORMS?</h3>
          <ul className="space-y-3 text-muted-foreground">
            <li className="flex items-start gap-3">
              <span className="text-accent font-bold">✓</span>
              <span><strong>PrizePicks</strong> - Best for player props and contests</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-accent font-bold">✓</span>
              <span><strong>Betr</strong> - Fastest micro-betting experience with STATLAB promo</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-accent font-bold">✓</span>
              <span><strong>Novig</strong> - Peer-to-peer betting with better odds</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-accent font-bold">✓</span>
              <span><strong>Pickit</strong> - Essential for tracking and analyzing your betting performance</span>
            </li>
          </ul>
        </div>
      </div>
    </Layout>
  );
}
